// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "astrojourney-6d0cd.firebaseapp.com",
  "projectId": "astrojourney-6d0cd",
  "storageBucket": "astrojourney-6d0cd.appspot.com",
  "messagingSenderId": "177188729100",
  "appId": "1:177188729100:web:830ad150da98d893051929",
  "measurementId": "G-8VJPGJV86R",
  "apiKey": "AIzaSyCAQYA6EF9D1sFYCI4Bxb1c8F7cc_ect60"
};
